module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0AQMAAAD/tomoAAAABlBMVEUxf/9FffsJaX8sAAAAAXRSTlMavYQhHAAAAC5JREFUGNNjYEAD9v8bGOT/H8CgLZj7/8swUk7jMh8XYP/DwMD8j3Y0LjBIwgEAeZFzLVsGBwwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico_interlayer@2x.png
// module id = wWkq
// module chunks = 0